import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import NotFound from '@/components/NotFound'
import oturumAc from '@/views/Auth/Login2'

// Layouts
import Layout1 from '@/layout/Layout1'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: [
    { path: '/Login', name: 'OturumAc', component: oturumAc },
    { path: '/Mail', name: 'Mail', component: () => import('@/views/Auth/Mail') },
    { path: '/Kayit', name: 'KayitOl', component: () => import('@/views/Auth/Register') },
    { path: '/hoca-kayit', name: 'HocaKayit', component: () => import('@/views/Auth/HocaKayit') },
    {
      path: '/',
      component: Layout1,
      redirect: '/anasayfa',
      children: [{
        path: '/anasayfa',
        component: () => import('@/views/Home')
      }, {
        path: '/Dosyalar/:id',
        name: 'Dosyalar',
        component: () => import('@/views/Dosya/Liste')
      }, {
        path: '/Sinav',
        name: 'Sinav',
        meta: [{
          Roles: ['Ogrenci']
        }],
        component: () => import('@/views/Sinav/Index')
      }, {
        path: '/Sinav/Liste',
        name: 'Sinavlar',
        meta: [{
          Roles: ['Admin']
        }],
        component: () => import('@/views/Sinav/Liste')
      }, {
        path: '/profilim',
        name: 'Profilim',
        meta: [{
          Roles: ['Ogrenci']
        }],
        component: () => import('@/views/Auth/ProfilDuzenle')
      }, {
        path: '/sonuclarim',
        name: 'Sonuclarim',
        meta: [{
          Roles: ['Ogrenci']
        }],
        component: () => import('@/views/Sinav/Sonuc')
      }, /* {
        path: '/sertifikam',
        name: 'Sertifika',
        meta: [{
          Roles: ['Ogrenci']
        }],
        component: () => import('@/views/Sertifika')
      }, */ {
        path: '/kullanici/liste',
        name: 'KullaniciListesi',
        meta: [{
          Roles: ['Admin', 'BolgeSorumlusu']
        }],
        component: () => import('@/views/Kullanici/Liste')
      }, {
        path: '/kullanici/ekleguncelle/:id?',
        name: 'KullaniciEkleGuncelle',
        meta: [{
          Roles: ['Admin', 'BolgeSorumlusu']
        }],
        component: () => import('@/views/Kullanici/EkleGuncelle')
      }, {
        path: '/ogrenci/liste',
        name: 'OgrenciListesi',
        meta: [{
          Roles: ['Admin', 'BolgeSorumlusu', 'Hoca']
        }],
        component: () => import('@/views/Ogrenci/Liste')
      }, {
        path: '/ogrenci/ekleguncelle/:id?',
        name: 'OgrenciEkleGuncelle',
        meta: [{
          Roles: ['Admin', 'BolgeSorumlusu', 'Hoca']
        }],
        component: () => import('@/views/Ogrenci/EkleGuncelle')
      }, {
        path: '/sinif/liste',
        name: 'SinifListesi',
        meta: [{
          Roles: ['Admin', 'BolgeSorumlusu', 'Hoca']
        }],
        component: () => import('@/views/Sinif/Liste')
      }, {
        path: '/sinif/ekleguncelle/:id?',
        name: 'SinifEkleGuncelle',
        meta: [{
          Roles: ['Admin', 'BolgeSorumlusu']
        }],
        component: () => import('@/views/Sinif/EkleGuncelle')
      }, {
        path: '/devamedenler',
        name: 'DevamEdenler',
        meta: [{
          Roles: ['Admin', 'BolgeSorumlusu']
        }],
        component: () => import('@/views/Ders/DevamEdenListe')
      }, {
        path: '/sinif/ogrenciler/:id?',
        name: 'SinifinOgrencileri',
        meta: [{
          Roles: ['Admin', 'BolgeSorumlusu', 'Hoca']
        }],
        component: () => import('@/views/Sinif/OgrenciListesi')
      }, {
        path: '/sinif/dosyalar/yukle/:id?',
        meta: [{
          Roles: ['Admin', 'BolgeSorumlusu', 'Hoca']
        }],
        name: 'SinifDosyaYukle',
        component: () => import('@/views/Dosya/EkleGuncelle')
      }, {
        path: '/sinif/dosyalar/:id?',
        name: 'SinifinDosyalari',
        meta: [{
          Roles: ['Admin', 'BolgeSorumlusu', 'Hoca']
        }],
        component: () => import('@/views/Sinif/DosyaListesi')
      }, {
        path: '/sinif/dersler/:id?',
        name: 'SinifinDersleri',
        meta: [{
          Roles: ['Admin', 'BolgeSorumlusu', 'Hoca']
        }],
        component: () => import('@/views/Ders/Liste')
      }, {
        path: '/sinif/ders/:sinifId/yoklamalar/:id?',
        name: 'DersinYoklamalari',
        meta: [{
          Roles: ['Admin', 'BolgeSorumlusu', 'Hoca']
        }],
        component: () => import('@/views/Yoklama/Liste')
      }, {
        path: '/sinif/yoklama/:id?',
        name: 'SinifinYoklamalari',
        meta: [{
          Roles: ['Admin', 'BolgeSorumlusu', 'Hoca']
        }],
        component: () => import('@/views/Yoklama/ListeV2')
      }, {
        path: '/sinif/odevler/:id?',
        name: 'SinifinOdevleri',
        meta: [{
          Roles: ['Admin', 'BolgeSorumlusu', 'Hoca']
        }],
        component: () => import('@/views/Odev/Liste')
      }, {
        path: '/sinif/odevler/:sinifId/ekleveguncelle/:id?',
        name: 'SinifOdevEkleGuncelle',
        meta: [{
          Roles: ['Admin', 'BolgeSorumlusu', 'Hoca']
        }],
        component: () => import('@/views/Odev/EkleGuncelle')
      }, {
        path: '/sinif/dersler/:sinifId/ekleguncelle/:id?',
        name: 'SinifDersEkleGuncelle',
        meta: [{
          Roles: ['Admin', 'BolgeSorumlusu', 'Hoca']
        }],
        component: () => import('@/views/Ders/EkleGuncelle')
      }, {
        path: '/dosyalar',
        name: 'TumDosyalar',
        meta: [{
          Roles: ['Admin', 'BolgeSorumlusu', 'Hoca']
        }],
        component: () => import('@/views/Dosya/FileManager')
      }, {
        path: '/rapor',
        name: 'Rapor',
        meta: [{
          Roles: ['Admin']
        }],
        component: () => import('@/views/Rapor/Raporlar')
      } /* , {
        path: '/sertifika-olusturucu',
        name: 'SertifikaOlusturucu',
        meta: [{
          Roles: ['Admin']
        }],
        component: () => import('@/views/SertifikaOlusturucu')
      } */ ]
    }, {
      // 404 Not Found page
      path: '*',
      component: NotFound
    }]
})
export default router
